import { FC } from 'react';
import classNames from 'classnames';

import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { getImagePackSet } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import { H1 } from '@rikstv/shared-components';

import { AssetImage } from '../../assetImage/AssetImage';
import { Breakpoints } from '../../grid/breakpoints';
import { SwimlaneItemImageOverlay } from '../../imageOverlays';
import { ProviderImageWrapper } from '../../providerImage/ProviderImageWrapper';
import { getLinkTo } from '../swimlane.utils';

import { ItemWrapper } from './ItemWrapper';
import { AgeLimitPill, RightBottomLabel } from './StandardItem';

import styles from './SuperWideHeroItem.module.css';

interface Props {
  item: SwimlaneItem;
  preventNavigation?: boolean;
  onClick?: () => void;
}

export const SuperWideHeroItem: FC<Props> = ({ item, preventNavigation, onClick }) => {
  const image = item.image;

  return (
    <ItemWrapper
      className={classNames(styles.asset, 'with-keyboard-focus')}
      preventDefault={preventNavigation}
      linkTo={getLinkTo(item)}
      onClick={onClick}>
      <H1 className="sr-only"> {item.title} </H1>
      <div className={styles.imageContainer}>
        <AssetImage
          ratio="21_9"
          imageSet={getImagePackSet({
            url: item.image.url,
            variations: [
              { height: 600, breakpoint: Breakpoints.XL },
              { height: 400, breakpoint: Breakpoints.SM },
              { height: 230, breakpoint: Breakpoints.DEFAULT },
            ],
          })}
          alt={item.title}
          blackWhite={image.bwFilter}
        />
        <SwimlaneItemImageOverlay programState={item.programState} />
        <ProviderImageWrapper logos={item.logos} width={'4%'} />
        <AgeLimitPill ageLimit={item.ageLimit} />
        <RightBottomLabel label={item.rightBottomLabel} />
      </div>
    </ItemWrapper>
  );
};
